import { cond, has, isEmpty } from 'lodash';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { BASE_URL } from '../../api/EndPoints';
import { createB2BAPI } from '../../api/Interceptor';
import B2BButton from '../../components/common/B2BButton';
import notify from '../../utils/Notification';
import { validateProductDescription, validateProductName } from '../../utils/Validation';
import ProductFabricContent from './ProductFabricContent';
import ProductCategorys from './ProductCategorys';
import ProductDimension from './ProductDimension';
import ProductType from './ProductType';
import ProductVariant from './ProductVariant';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';
import { useLoader } from '../../Context/LoaderContext';
import { ProductContext } from '../../Context/ProductContext';
import ProductManagement from './ProductManagement';
import { SwipeableDrawer } from '@mui/material';
import { Accordion, Modal } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const CreateProduct = () => {
  const initialTabs = [
    { id: "1", name: "Draft Product Info", disabled: false },
    { id: "2", name: "InProgress Product Info", disabled: false },
    { id: "3", name: "Final Info", disabled: false },
  ];

  const [condition, setCondition] = useState(false);
  const [tabs, setTabs] = useState(initialTabs);
  const [hasMultiSelectCategoryMandatory, setHasMultiSelectCategoryMandatory] = useState([]);
  const navigate = useNavigate();
  const ismobile = useMediaQuery("(max-width: 767px)");
  const location = useLocation();
  const tabinfo = location.state?.activeTab;
  const query_param = new URLSearchParams(location.search);
  const to = query_param.get('toUrl');
  const from = query_param.get('from');
  const page = query_param.get('page');
  const size = query_param.get('size');
  const search = query_param.get('search');
  const { showLoader, hideLoader } = useLoader();
  const [isSaving, setIsSaving] = useState(false);
  const [rejectModalOpened, setRejectModalOpened] = useState(false);
  const [hasOpenedWipTab, setHasOpenedWipTab] = useState(false);
  const [swatchNotifyData, setSwatchNotifyData] = useState({
    awbNumber: '',
    docNumber: '',
    courierName: '',
    swatchQuantity: '',
    dispatchDate: '',
    deliveryDate: '',
  });

  const initialState = {
    productId: '',
    articleName: null,
    articleCode: null,
    description: '',
    supplier: '',
    isCreateBarcode: true,
    createBatch: false,
    hsnCode: '',
    readyStock: false,
    vendorReadyStock: false,
    orderDriven: false,
    mappedFabric: '',
    tags: [],
    metrics: {
      weight: 0,
      thickness: 0,
      length: 0,
      width: 0,
      inches: 0,
      centimeter: 0,
      meter: 0,
      meterSqKg: 0,
    },
    vendorProductInfo: {
      sampleAvailable: false,
      swatchAvailable: false,
      swatchSent: '',
      swatchReceived: '',
      costPrice: 0,
      commission: '',
      ussId: '',
      commissionPercentage: '',
      vendorProductId: '',
      coneWeight: '',
      vendorProductName: '',
      priceInclConeWeight: '',
      moq: '',
      mcq: ''
    },
    otherInformation: {
      skuPrefix: '',
      coneWeight: '',
      unitOfMeasures: {
        type: 'UOM',
        isKg: false,
        isMeter: false,
        isYard: false,
      }
    },
    prodVariants: {},
    vendorProductCode: '',
    vendorProductName: '',
    productVariants: [],
    productCategories: {},
    newProductVariants: [],
    fabricContent: {
      value: "",
      composition: {}
    },
    totalProductPercent: '',
    vendorImage: '',
    vendorImages: [],
    priceSetting: {
      isMarkUp: false,
      isMarkDown: false,
      costPrice: 0,
      markUpPercent: 0,
      markDownPercent: 0,
      sellingPrice: 0,
      mrp: 0,
      margin: 0,
    },
    categoryId: '',
    brandId: '',
    status: 'ACTIVE'
  };

  const [product, setProduct] = useState(initialState);
  const [isNameEdited, setIsNameEdited] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [activeTab, setActiveTab] = useState("0");
  const [isFormValid, setIsFormValid] = useState(false);
  const B2B_API = createB2BAPI();
  const [status, setStatus] = useState('ACTION');
  const [colourFile, setColourFile] = useState(null);
  const [inputError, setInputError] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  console.log(inputError, imageFile, "seee")

  const checkDirectValue = (key) => {
    if (key === 'brandId') return true;
    if (key === 'taxonomyNode') return true;
  };

  const query_paramm = new URLSearchParams(location.search);
  const idd = query_paramm.get('id');
  const isEditMode = product?.draftProductId ? true : false;
  useEffect(() => {
    if (product?.colourVaraint) {
      // if backend already has a file
      setColourFile(`${BASE_URL}${product.colourVaraint.replace("/api", "")}`);
    }
  }, [product]);
  useEffect(() => {
    const query_param = new URLSearchParams(location.search);
    const id = query_param.get('id');
    if (id) {
      fetchProduct(id);
    }
  }, [location.search]);

  const hasProductManagementData = useMemo(() => {
    const { centimeter, inches, meter, weight } = product.metrics || {};
    const hasMetrics = [centimeter, inches, meter, weight].every(
      v => typeof v === 'number' && v > 0
    );
    const cw = product.otherInformation?.coneWeight;
    const hasOther = typeof cw === 'number' && cw > 0;
    const hasVariants = Array.isArray(product.newProductVariants) && product.newProductVariants.length > 0;
    const hasCategories = Boolean(product.productCategories) && Object.keys(product.productCategories).length > 0;
    const hasCatList = Array.isArray(product.productCategoriesList) && product.productCategoriesList.length > 0;
    const hasFabric = Boolean(product.fabricContent?.value)
      && typeof product.fabricContent.composition === 'object'
      && Object.keys(product.fabricContent.composition).length > 0;

    return hasMetrics && hasOther && hasVariants && hasCategories && hasCatList && hasFabric;
  }, [
    product.metrics?.centimeter,
    product.metrics?.inches,
    product.metrics?.meter,
    product.metrics?.weight,
    product.otherInformation?.coneWeight,
    product.newProductVariants,
    product.productCategories,
    product.productCategoriesList,
    product.fabricContent?.value,
    product.fabricContent?.composition,
  ]);

  const handleChange = (event, fieldType, errorName, key) => {
    const value = event?.target?.type === 'checkbox' ? event?.target?.checked : event?.target?.value;
    setInputError((prev) => ({
      ...prev,
      [errorName]: "",
      ...(fieldType === "vendorProductCode" || fieldType === "vendorProductId" ? { vendorProductCodeErrorMessage: "", productIdErrorMessage: "" } : {}),
      ...(fieldType === "vendorProductName" ? { vendorProductNameErrorMessage: "", productNameErrorMessage: "" } : {}),
      ...(fieldType === "metrics.weight" || fieldType === "weight" ? { gsmErrorMessage: "", weightErrorMessage: "" } : {}),
    }));
    if (fieldType === "vendorProductName") {
      if (value && typeof value === 'string' && value.trim() !== '') {
        setIsNameEdited(true);
      } else {
        setIsNameEdited(false);
      }
      setProduct(prev => ({
        ...prev,
        ...(prev.orderDriven ? {} : { articleName: value }),
        vendorProductName: value,
        vendorProductInfo: {
          ...(prev.vendorProductInfo || {}),
          vendorProductName: value
        }
      }));
      return;
    }
    if (fieldType === "width") {
      setProduct(prev => ({
        ...prev,
        metrics: {
          ...(prev.metrics || {}),
          width: value
        }
      }));
      setInputError(prev => ({ ...prev, widthErrorMessage: '' }));
      return;
    }
    if (fieldType === "vendorProductCode" || fieldType === "vendorProductId") {
      if (!isNameEdited) {
        setInputError(prev => ({ ...prev, productNameErrorMessage: '', vendorProductNameErrorMessage: '' }));
      }
      setProduct(prev => ({
        ...prev,
        vendorProductCode: value,
        articleCode: value,
        ...(isNameEdited || prev.orderDriven ? {} : {
          articleName: value,
        }),
        ...(isNameEdited ? {} : {
          vendorProductName: value,
        }),
        vendorProductInfo: {
          ...(prev.vendorProductInfo || {}),
          vendorProductId: value,
          ...(isNameEdited ? {} : {
            vendorProductName: value,
          }),
        }
      }));
      return;
    }
    if (fieldType === 'vendorProductInfo.coneWeight') {
      setProduct((prev) => ({
        ...prev,
        otherInformation: {
          ...prev.otherInformation,
          coneWeight: value / 1000,
        },
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          coneWeight: value / 1000,
        }
      }));
    }
    if (fieldType === 'priceSetting.costPrice') {
      setProduct((prev) => ({
        ...prev,
        priceSetting: {
          ...prev.priceSetting,
          costPrice: '',
        },
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          costPrice: value,
        }
      }));
    }
    if (fieldType === 'totalProductPercent') {
      setProduct((prev) => ({
        ...prev,
        totalProductPercent: value,
      }));
    }

    if (fieldType === 'vendorProductInfo.ussId') {
      setProduct((prev) => ({
        ...prev,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          ussId: value,
        }
      }));
    }
    if (fieldType === 'vendorProductInfo.sampleAvailable') {
      setProduct((prev) => ({
        ...prev,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          sampleAvailable: value,
        }
      }));
    }
    if (fieldType === "hsnCode") {
      const { value } = event.target;
    }
    if (fieldType === "mappedFabric") {
      setProduct(prev => ({
        ...prev,
        [key]: value
      }));
    }
    if (fieldType === "UOM") {
      const { value, checked } = event.target;
      setProduct((prevState) => {
        const updatedUnitOfMeasures = {
          isRoll: true,
          isKg: value === "isKg",
          isMeter: value === "isMeter",
          isYard: value === "isYard",
        };
        const updatedOtherInformation = {
          ...prevState.otherInformation,
          unitOfMeasures: updatedUnitOfMeasures,
          kilogram: !updatedUnitOfMeasures.isKg ? "" : prevState.otherInformation.kilogram,
          meter: !updatedUnitOfMeasures.isMeter ? "" : prevState.otherInformation.meter,
          yard: !updatedUnitOfMeasures.isYard ? "" : prevState.otherInformation.yard,
        };
        return {
          ...prevState,
          otherInformation: updatedOtherInformation,
        };
      });
    } else if (fieldType.includes('.')) {
      const [parent, child] = fieldType.split('.');
      setProduct((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else if (['swachCardStatus', 'sellAscombo'].includes(fieldType)) {
      setProduct(prev => ({
        ...prev,
        [fieldType]: value
      }));
    } else if (fieldType === 'isCreateBarcode' || fieldType === 'createBatch') {
      setProduct(prev => ({
        ...prev,
        [fieldType]: 'true' === event?.target?.value,
      }));
    } else if (['sampleMOQ', 'wholesaleMOQ', 'minMargin', 'allowLoyalty', 'isStopGRN', 'isStopPurchaseReturn', 'isStopSale',
      'isAllowRefund', 'isAllowNegative', 'isAllowCostEditInGRN', 'isEnableSerialNumber', 'isNonTrading', 'metaDescription', 'productSlug', 'url', 'kilogram', 'meter', 'yard', 'coneWeight'].includes(fieldType)) {
      setProduct((prev) => {
        const updatedState = {
          ...prev,
          otherInformation: {
            ...prev.otherInformation,
            [fieldType]: value,
          },
        };
        return updatedState;
      });
    } else if (fieldType.startsWith('variantImage')) {
      const variantIndex = fieldType.split('-')[1];
      setProduct(prev => ({
        ...prev,
        variants: prev.variants.map((variantGroup, idx) => {
          if (idx === parseInt(variantIndex)) {
            return variantGroup.map(variant => ({
              ...variant,
              image: file
            }));
          }
          return variantGroup;
        })
      }));
    } else if (fieldType === 'mappedFabric') {
      setProduct((prev) => ({
        ...prev,
        [fieldType]: event
      }));
    } else {
      setProduct(prev => ({
        ...prev,
        [fieldType]: checkDirectValue(fieldType) ? event : event?.target?.value,
      }));
    }
  };

  const addProduct = async (prod, hasGEData) => {
    try {
      showLoader();
      const res = await B2B_API.post(`draftProduct`, {
        body: prod,
      }).json();

      const draftId = res?.response?.draftProductId || product?.draftProductId;

      if (hasGEData && draftId) {
        const payload = {
          draftProductId: draftId,
          ...swatchNotifyData,
          swatchSent: true,
          swatchRequest: true,
          saveGe: false,
        };
        try {
          await B2B_API.post(`swatchNotifyData/create`, { json: payload, throwHttpErrors: false });
          if (!product?.swatchSent && !product?.vendorProductInfo?.swatchSent) {
            await B2B_API.get(`draftProduct/updateSwatchSent?id=${draftId}`, { throwHttpErrors: false });
          }
        } catch (e) {
          console.log("Swatch GE info:", e);
        }
      }

      setProduct(initialState);
      setIsNameEdited(false);
      setImageFile(null);
      setColourFile?.(null);
      setActiveTab("0");
      notify({
        id: product?.id ? "Updated Successfully" : "Added Successfully",
        title: 'Success!!',
        message: hasGEData ? "Product Saved & Sent to WIP Tab Successfully" : (product?.id ? "Updated Successfully" : res?.message),
        error: false,
        success: true,
      });

      if (hasGEData) {
        navigate('/VendorHome', { state: { activeTab: 'Request Info', tabinfo: 'Request Info' } });
      } else {
        navigate('/VendorHome', { state: { activeTab: 'Draft', tabinfo: 'Draft' } });
      }
    } catch (err) {
      notify({
        title: 'Error!!',
        message: err?.message || 'Failed to add product.',
        error: true,
        success: false,
      });
    } finally {
      hideLoader();
      setIsSaving(false);
    }
  };

  const renderActiveComponent = () => {
    switch (activeTab) {
      case "0":
        return <ProductVariant isReadOnly={false} tabInfo={tabinfo} />;
      case "1":
        return <ProductType isReadOnly={false} isCondition={condition} tabInfo={tabinfo} />;
      case "2":
        return <ProductManagement isCondition={condition} tabInfo={tabinfo} />;
      case "3":
        return <ProductDimension isCondition={condition} tabInfo={tabinfo} />;
      default:
        return <ProductVariant isReadOnly={false} tabInfo={tabinfo} />;
    }
  };
  //  return <ProductType isReadOnly={isEditMode} isCondition={condition} />;
  // case "2":
  //   return <ProductManagement isCondition={condition} tabInfo={tabinfo} />;
  // case "3":
  //   return <ProductDimension isCondition={condition} />;
  // default:
  //   return <ProductVariant isReadOnly={isEditMode} />;
  const handleBackTab = () => {
    const prevTabIndex = tabs.findIndex(tab => tab.id === activeTab) - 1;
    if (prevTabIndex >= 0) {
      setActiveTab(tabs[prevTabIndex].id);
    }
  };

  const enableNextTab = (isDisabled) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.map((tab, index) => {
        if (tab.id === activeTab) {
          const nextIndex = index + 1;
          if (nextIndex < prevTabs.length) {
            prevTabs[nextIndex].disabled = isDisabled;
          }
        }
        return tab;
      });
      return [...updatedTabs];
    });
  };
  const validateProduct = (isWipCheck = false) => {
    let isValid = true;
    const errors = {};

    // --- Vendor Product Name ---
    if (!product?.orderDriven && (!product?.vendorProductName || product?.vendorProductName.trim() === "")) {
      errors.vendorProductNameError = true;
      errors.vendorProductNameErrorMessage = "Vendor Product Name is required!";
      isValid = false;
    } else {
      errors.vendorProductNameError = false;
      errors.vendorProductNameErrorMessage = "";
    }

    // --- Vendor Product Code ---
    if (!product?.vendorProductCode || product?.vendorProductCode.trim() === "") {
      errors.vendorProductCodeError = true;
      errors.vendorProductCodeErrorMessage = "Vendor Product Code is required!";
      isValid = false;
    } else {
      errors.vendorProductCodeError = false;
      errors.vendorProductCodeErrorMessage = "";
    }

    // --- GSM ---
    if (!product?.metrics?.weight || product?.metrics?.weight <= 0) {
      errors.gsmError = true;
      errors.gsmErrorMessage = "GSM must be greater than zero!";
      isValid = false;
    } else {
      errors.gsmError = false;
      errors.gsmErrorMessage = "";
    }

    const hasStockType = Boolean(product?.readyStock || product?.vendorReadyStock || product?.orderDriven);
    if (!hasStockType) {
      errors.stockTypeError = true;
      errors.stockTypeErrorMessage = "Stock Type is required!";
      isValid = false;
    } else {
      errors.stockTypeError = false;
      errors.stockTypeErrorMessage = "";
    }

    const vendorImagesLength = product?.vendorImages?.length || 0;
    const imageFileLength = imageFile?.length || 0;

    if (vendorImagesLength === 0 && imageFileLength === 0) {
      errors.imageError = true;
      errors.imageErrorMessage = "Please upload Image!";
      isValid = false;
    } else {
      errors.imageError = false;
      errors.imageErrorMessage = "";
    }

    const isFabricContentValid =
      product?.fabricContent?.composition &&
      Object.keys(product.fabricContent.composition).length > 0 &&
      Object.values(product.fabricContent.composition).every((v) => v);

    if (!isFabricContentValid) {
      errors.fabricContentError = true;
      errors.fabricContentErrorMessage = "FCC must be selected!";
      isValid = false;
    } else {
      errors.fabricContentError = false;
      errors.fabricContentErrorMessage = "";
    }

    if (
      typeof product?.totalProductPercent === "number" &&
      product.totalProductPercent !== 100
    ) {
      errors.fabricCompositionError = true;
      errors.fabricCompositionErrorMessage =
        "Overall composition percentage must be 100%";
      isValid = false;
    } else {
      errors.fabricCompositionError = false;
      errors.fabricCompositionErrorMessage = "";
    }

    // --- Cone Weight ---
    if (!product?.orderDriven && product?.vendorProductInfo?.priceInclConeWeight === true) {
      if (!product?.otherInformation?.coneWeight || product.otherInformation.coneWeight <= 0) {
        errors.coneWeightError = true;
        errors.coneWeightErrorMessage = "Cone weight must be greater than zero!";
        isValid = false;
      } else {
        errors.coneWeightError = false;
        errors.coneWeightErrorMessage = "";
      }
    } else {
      errors.coneWeightError = false;
      errors.coneWeightErrorMessage = "";
    }

    if (!(product?.otherInformation?.unitOfMeasures?.isKg || product?.otherInformation?.unitOfMeasures?.isMeter || product?.otherInformation?.unitOfMeasures?.isYard)) {
      errors.uomError = true;
      errors.uomErrorMessage = "UOM Is Required !!";
      isValid = false;
    } else {
      errors.uomError = false;
    }

    // --- Width ---
    if (!product?.metrics?.width || product?.metrics?.width <= 0) {
      errors.widthError = true;
      errors.widthErrorMessage = "Width must be greater than zero!";
      isValid = false;
    } else {
      errors.widthError = false;
      errors.widthErrorMessage = "";
    }

    // --- Fiber Details (Wrap & Wefp) for Vendor Stock ---
    const isVendorStockMode = Boolean(
      product?.vendorReadyStock ||
      product?.vendorProductInfo?.vendorReadyStock ||
      (product?.readyStock || product?.vendorProductInfo?.readyStock) ||
      (!product?.orderDriven && !product?.vendorProductInfo?.orderDriven)
    );

    if (isVendorStockMode) {
      let warpWeftMap = {};
      try {
        const rawVal = product?.warpWeftDetails || product?.vendorProductInfo?.warpWeftDetails;
        warpWeftMap = typeof rawVal === 'string' ? JSON.parse(rawVal || '{}') : (rawVal || {});
      } catch (e) {
        warpWeftMap = {};
      }

      const compositionObj = product?.fabricContent?.composition || product?.vendorProductInfo?.fabricContent?.composition || {};
      const fabricContentArr = product?.otherInformation?.fabricContent || product?.vendorProductInfo?.otherInformation?.fabricContent || [];

      const keysFromComp = Object.keys(compositionObj).filter(k => k && k.trim() !== "");
      const keysFromArr = fabricContentArr.map(p => p?.key).filter(k => k && k.trim() !== "");

      const allFabricKeys = Array.from(new Set([...keysFromComp, ...keysFromArr]));

      let hasMissingWarpWeft = false;
      if (allFabricKeys.length === 0) {
        hasMissingWarpWeft = true;
      } else {
        for (const fabricKey of allFabricKeys) {
          const itemObj = warpWeftMap[fabricKey] || {};
          const itemWarp = itemObj?.warp || Object.values(warpWeftMap).find(v => v?.fabricName === fabricKey)?.warp;
          const itemWeft = itemObj?.weft || itemObj?.wefp || Object.values(warpWeftMap).find(v => v?.fabricName === fabricKey)?.weft || Object.values(warpWeftMap).find(v => v?.fabricName === fabricKey)?.wefp;

          if (!itemWarp || !itemWarp.toString().trim() || !itemWeft || !itemWeft.toString().trim()) {
            hasMissingWarpWeft = true;
            break;
          }
        }
      }

      if (hasMissingWarpWeft) {
        errors.warpWeftError = true;
        errors.warpWeftErrorMessage = "Wrap and Wefp details are required for all selected fabrics!";
        isValid = false;
      } else {
        errors.warpWeftError = false;
        errors.warpWeftErrorMessage = "";
      }
    } else {
      errors.warpWeftError = false;
      errors.warpWeftErrorMessage = "";
    }

    const isAlreadyWipProduct = Boolean(product?.swatchSent === true || product?.requestedInformation === true);
    const checkWip = isWipCheck || activeTab === "2" || activeTab === "3" || isAlreadyWipProduct;

    if (checkWip) {
      // --- Categories ---
      const hasMandatoryCategorySelected =
        product?.productCategories &&
        Array.isArray(product.productCategories) &&
        product.productCategories.length > 0 &&
        product.productCategories
          .filter((cat) => cat.isMandatory)
          .every((cat) => cat.value && Object.keys(cat.value).length > 0);

      if (!hasMandatoryCategorySelected) {
        errors.categoryError = true;
        errors.categoryErrorMessage = "Select all mandatory categories!";
        isValid = false;
      } else {
        errors.categoryError = false;
        errors.categoryErrorMessage = "";
      }

      // --- Variants ---
      if (!product?.orderDriven) {
        const hasVariants =
          (Array.isArray(product?.newProductVariants) && product.newProductVariants.length > 0) ||
          (Array.isArray(product?.productVariants) && product.productVariants.length > 0) ||
          (product?.prodVariants &&
            Object.values(product.prodVariants).some(
              (variantArray) => Array.isArray(variantArray) && variantArray.length > 0
            ));

        if (!hasVariants) {
          errors.VariantError = true;
          errors.VariantErrorMessage = "Select variants!";
          isValid = false;
        } else {
          errors.VariantError = false;
          errors.VariantErrorMessage = "";
        }
      } else {
        errors.VariantError = false;
        errors.VariantErrorMessage = "";
      }
    }

    if (!isValid) {
      if (
        errors.vendorProductNameError ||
        errors.vendorProductCodeError ||
        errors.gsmError ||
        errors.stockTypeError ||
        errors.imageError ||
        errors.fabricContentError ||
        errors.fabricCompositionError ||
        errors.warpWeftError ||
        errors.coneWeightError ||
        errors.uomError ||
        errors.widthError
      ) {
        setActiveTab("1");
      } else if (
        errors.categoryError ||
        errors.VariantError
      ) {
        setActiveTab("2");
      }
    }

    setInputError((prev) => ({ ...prev, ...errors }));
    return isValid;
  };




  const convertMeterToYard = () => {
    const res = product.otherInformation.meter * 1.09632;
    return res.toFixed(2);
  };

  const mapNewToProductVariants = (newVariants = []) => {
    return newVariants.map(nv => ({
      id: nv.id,
      name: nv.name,
      status: nv.status,
      variants: Array.isArray(nv.variants)
        ? nv.variants.map(v => ({
          id: v.variantId && v.id !== v.variantId ? v.id : null,
          variantId: v.variantId || v.id,
          name: v.name,
          value: v.value,
          type: v.type,
          hexaColorCode: v.hexaColorCode,
          image: v.image
        }))
        : []
    }));
  };

  const handleProductReject = async () => {
    try {
      showLoader();
      const draftId = product?.draftProductId || product?.id;
      if (!draftId) {
        notify({ error: true, title: 'Draft Product ID not found' });
        return;
      }
      await B2B_API.post(`draftProduct/rejectProduct?draftProductId=${draftId}`).json();
      notify({ success: true, title: 'Product Rejected Successfully' });
      handleCancel();
    } catch (error) {
      notify({ error: true, title: error?.message || 'Failed to reject product' });
    } finally {
      hideLoader();
    }
  };

  const handleProductSave = async () => {
    if (isSaving) return;
    console.log("nknkkkkkkkkkkk")
    const valid = validateProduct();
    console.log(valid, "---------validate -------------")
    if (!valid) {
      notify({
        error: true,
        success: false,
        title: "Please fill all required mandatory fields before saving!"
      });
      return;
    }
    setIsSaving(true);
    const formData = new FormData();
    let updatedProduct = { ...product };
    if (updatedProduct.orderDriven) {
      delete updatedProduct.articleName;
    }
    const warpWeftVal = updatedProduct.warpWeftDetails || updatedProduct.vendorProductInfo?.warpWeftDetails || '';
    updatedProduct.warpWeftDetails = warpWeftVal;
    if (updatedProduct.vendorProductInfo) {
      updatedProduct.vendorProductInfo.warpWeftDetails = warpWeftVal;
    }

    const rawVariants = (Array.isArray(updatedProduct.newProductVariants) && updatedProduct.newProductVariants.length > 0)
      ? updatedProduct.newProductVariants
      : (Array.isArray(updatedProduct.productVariants) && updatedProduct.productVariants.length > 0)
        ? updatedProduct.productVariants
        : [];
    updatedProduct.productVariants = mapNewToProductVariants(rawVariants);

    if (activeTab != "1") {
      updatedProduct.productCategories = Array.isArray(updatedProduct.productCategories)
        ? updatedProduct.productCategories.reduce((acc, item) => {
          const value = item.value;
          value.heirarchyLabel = item.heirarchyLabel;
          acc[item.key] = value;
          return acc;
        }, {})
        : {};
      if (updatedProduct.otherInformation?.unitOfMeasures?.isMeter) {
        updatedProduct.otherInformation.yard = convertMeterToYard();
      }
    }
    const allStandardTColourImages = updatedProduct.standardtcolourimage || [];
    const existingImageUrls = allStandardTColourImages.filter(img => typeof img === 'string');
    const newImageFiles = allStandardTColourImages.filter(img => img instanceof File || img instanceof Blob);

    updatedProduct.standardtcolourimage = existingImageUrls.length > 0 ? existingImageUrls : null;
    delete updatedProduct.standardcolourimage;
    delete updatedProduct.prodVariants;
    delete updatedProduct.vendorImages1;

    const isGEFieldsFilled = Boolean(
      swatchNotifyData.awbNumber?.trim() ||
      swatchNotifyData.docNumber?.trim() ||
      swatchNotifyData.courierName?.trim() ||
      swatchNotifyData.swatchQuantity ||
      swatchNotifyData.dispatchDate ||
      swatchNotifyData.deliveryDate
    );

    // Product already submitted to WIP (existing product with swatchSent=true)
    const isAlreadyWip = Boolean(product?.swatchSent === true || product?.requestedInformation === true);

    const hasGEData = activeTab === "2" || activeTab === "3" || isAlreadyWip || hasOpenedWipTab || hasProductManagementData;

    if (hasGEData) {
      updatedProduct.requestedInformation = true;
    } else {
      updatedProduct.requestedInformation = false;
    }

    const hasActualNotifyData = Boolean(
      swatchNotifyData?.awbNumber?.trim() ||
      swatchNotifyData?.docNumber?.trim() ||
      swatchNotifyData?.courierName?.trim()
    );

    if (hasActualNotifyData || product?.swatchSent === true || product?.vendorProductInfo?.swatchSent === true) {
      updatedProduct.swatchSent = true;
      updatedProduct.swatchRequest = true;
    } else {
      updatedProduct.swatchSent = false;
      updatedProduct.swatchRequest = false;
    }

    const cleanedProduct = JSON.parse(JSON.stringify(updatedProduct, (key, value) => {
      if (typeof value === 'string' && value.startsWith('data:image')) {
        return undefined;
      }
      return value;
    }));

    formData.append("product", JSON.stringify(cleanedProduct));

    if (Array.isArray(imageFile)) {
      imageFile.forEach(file => {
        if (file instanceof File || file instanceof Blob) {
          formData.append("image", file);
        }
      });
    }

    newImageFiles.forEach((file) => {
      formData.append("standardtcolourimage", file);
    });

    if (colourFile instanceof File || colourFile instanceof Blob) {
      formData.append("colourVariant", colourFile);
    }

    addProduct(formData, hasActualNotifyData);
  };

  const enableAllTabs = () => {
    const updatedTabs = tabs.map((tab) => ({ ...tab, disabled: false }));
    setTabs(updatedTabs);
  };

  const fetchProduct = async (id) => {
    try {
      setIsFetching(true);
      showLoader();
      const response = await B2B_API.get(`draftProduct/get/${id}`).json();
      const product = response.response;
      const barcodeString = product?.isCreateBarcode ? "true" : "false";
      enableAllTabs();
      const transformData = () => {
        const result = {};
        product?.productVariants.forEach(variant => {
          variant.variants.forEach(v => {
            if (!result[v.name]) {
              result[v.name] = new Set();
            }
            result[v.name].add(v.variantId || v.id);
          });
        });
        for (const key in result) {
          result[key] = Array.from(result[key]);
        }
        return result;
      };
      const calculateTotalPercent = (composition) => {
        return Object.values(composition).reduce((sum, value) => sum + parseInt(value, 10), 0);
      };
      const fetchHeirarchy = async (parentId) => {
        let heirarchy = [];
        let currentId = parentId;
        while (currentId) {
          try {
            const res = await B2B_API.get(`product-category/category/${currentId}`).json();
            const category = res.response;
            if (category) {
              heirarchy.push(category.name);
              currentId = category.parentId;
            } else {
              currentId = null;
            }
          } catch (error) {
            console.error('Error category : ', error);
            currentId = null;
          }
        }
        return heirarchy.reverse();
      };
      const transformCategories = async () => {
        const result = [];
        for (const [key, value] of Object.entries(product?.productCategories || {})) {
          const heirarchy = await fetchHeirarchy(value.categoryId || value.id);
          const heirarchyLabel = heirarchy?.slice(1).join('/');
          result.push({
            key: key,
            value: value,
            heirarchyLabel: heirarchyLabel,
            options: value.options || [],
            openModal: false
          });
        }
        return result;
      };
      const adjustPriceSetting = (priceSetting) => {
        return {
          ...priceSetting,
          isMarkDown: priceSetting.markDownPercent > 0 ? true : false,
          isMarkUp: priceSetting.markUpPercent > 0 ? true : false,
        };
      };
      setCondition(product.productVariants.length > 0);
      const imageUrls = product?.vendorImages
        ?.filter((imgPath) => imgPath && imgPath.trim() !== "")
        .map((imgPath) => `${BASE_URL}${imgPath.replace("/api", "")}`) || [];
      setIsNameEdited(Boolean(product?.vendorProductName));
      setProduct({
        ...product,
        tags: product?.productTags?.split(",").map(tag => tag.trim()),
        brandId: product?.brand?.brandId,
        taxonomy: product?.taxonomy?.name,
        totalProductPercent: calculateTotalPercent(product?.fabricContent?.composition || {}),
        barcode: barcodeString,
        otherInformation: {
          coneWeight: product?.otherInformation?.coneWeight,
          unitOfMeasures: {
            isKg: product?.otherInformation.unitOfMeasures?.isKg || false,
            isMeter: product?.otherInformation.unitOfMeasures?.isMeter || false,
            isRoll: product?.otherInformation.unitOfMeasures?.isRoll || false,
            isYard: product?.otherInformation.unitOfMeasures?.isYard || false
          },
        },
        metrics: {
          centimeter: product?.metrics?.centimeter,
          inches: product?.metrics?.inches,
          meter: product?.metrics?.meter,
          weight: product?.metrics?.weight,
          editWeight: product?.metrics?.weight > 0,
          width: product?.metrics?.width,
        },
        vendorProductInfo: {
          ...product?.vendorProductInfo,
          sampleAvailable: product?.vendorProductInfo?.sampleAvailable,
          swatchAvailable: product?.vendorProductInfo?.swatchAvailable,
          swatchSent: product?.vendorProductInfo?.swatchSent,
          swatchReceived: product?.vendorProductInfo?.swatchReceived,
          costPrice: product?.vendorProductInfo?.costPrice,
          vendorProductId: product?.vendorProductInfo?.vendorProductId,
          vendorProductName: product?.vendorProductInfo?.vendorProductName,
          commission: product?.vendorProductInfo?.commission,
          coneWeight: product?.vendorProductInfo?.coneWeight,
          priceInclConeWeight: product?.vendorProductInfo?.priceInclConeWeight,
          warpWeftDetails: product?.warpWeftDetails || product?.vendorProductInfo?.warpWeftDetails,
          moq: product?.moq || product?.vendorProductInfo?.moq || '',
          mcq: product?.mcq || product?.vendorProductInfo?.mcq || '',
        },
        moq: product?.moq || product?.vendorProductInfo?.moq || '',
        mcq: product?.mcq || product?.vendorProductInfo?.mcq || '',
        warpWeftDetails: product?.warpWeftDetails || product?.vendorProductInfo?.warpWeftDetails,
        fabricContent: product?.fabricContent ? product?.fabricContent : {
          value: '',
          composition: {},
        },
        editFabricContent: product?.fabricContent?.value,
        colourVaraint: product?.colourVaraint || product?.vendorProductInfo?.colourVaraint || product?.colourVariant,
        standardtcolourimage: product?.standardtcolourimage || product?.vendorProductInfo?.standardtcolourimage || product?.standardcolourimage || [],
        vendorImages1: imageUrls,
        productCategories: await transformCategories(),
        prodVariants: transformData(),
        newProductVariants: Array.isArray(product?.newProductVariants) && product.newProductVariants.length
          ? product.newProductVariants
          : Array.isArray(product?.productVariants) && product.productVariants.length
            ? product.productVariants
            : []
      });
      const fetchImageAsBlob = async () => {
        try {
          const images = product?.vendorImages;
          if (images?.length === 0) return [];
          const files = await Promise.all(
            images.map(async (url, index) => {
              const response = await fetch(`${BASE_URL}${url.replace('/api', '')}`);
              const contentType = response.headers.get('Content-Type');
              if (!contentType || !contentType.startsWith('image/')) {
                throw new Error('Expected an image, but received: ' + contentType);
              }
              const blob = await response.blob();
              return new File([blob], `image-${index}.jpeg`, { type: blob.type });
            })
          );
          return files;
        } catch (error) {
          console.error('Error fetching images:', error);
          throw error;
        }
      };
    } catch (err) {
      notify({
        title: 'Error!',
        message: err?.message || 'Failed to fetch product.',
        error: true,
        success: false,
      });
    } finally {
      setIsFetching(false);
      hideLoader();
    }
  };

  const handleCancel = () => {
    navigate('/VendorHome', { state: { tabinfo } });
  };

  const isFabricContentFilled =
    product?.fabricContent?.id ||
    (product?.fabricContent?.value && Object.keys(product.fabricContent.composition || {}).length > 0);
  const showSaveButton =
    !(product?.draftProductId && (isFabricContentFilled)) ||
    (product?.draftProductId && (!isFabricContentFilled || !product?.productVariants?.length || product?.productVariants?.length < 1));

  const actualTabInfo = tabinfo || (product?.rejectProduct ? "Rejected" : (product?.requestedInformation ? "Request Info" : "Draft"));
  const isRejected = actualTabInfo === "Rejected" || Boolean(product?.rejectProduct);
  const isViewOnly = isRejected;

  return (
    <ProductContext.Provider value={{ product, handleChange, addProduct, setProduct, imageFile, setImageFile, inputError, setInputError, setHasMultiSelectCategoryMandatory, colourFile, setColourFile, swatchNotifyData, setSwatchNotifyData, validateProduct }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '3rem' }}>
        {!product?.draftProductId ? <h1></h1> : <h1 style={{ display: 'flex', fontSize: ismobile ? '18px' : '24px', alignItems: 'center', fontWeight: 'bold', color: "#8BC53F", marginLeft: '1rem' }}>{product?.vendorProductName}</h1>}
        {!product?.draftProductId && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '5px',
              background: '#fffbeb', border: '1px solid #fcd34d',
              borderRadius: '6px', padding: '4px 10px', fontSize: '11px', color: '#92400e'
            }}>
              <span style={{ color: '#92400e', fontSize: "14px" }}><b>NOTE : </b> </span>
              <span style={{ color: '#92400e', fontSize: "14px" }}> You can save <b>Draft Product Info</b> Only OR All Other Sections. If you open a section, fill all its mandatory fields.</span>
            </div>
            <B2BButton style={{ color: '#000', marginRight: '1rem' }} name="Back" onClick={() => handleCancel()} leftSection={<IconArrowLeft size={15} />} color={"#c9e8b8"} />
          </div>
        )}
        {product?.draftProductId && (
          <B2BButton style={{ color: '#000', marginRight: '1rem' }} name="Back" onClick={() => handleCancel()} leftSection={<IconArrowLeft size={15} />} color={"#c9e8b8"} />
        )}
      </div>
      <Accordion
        value={activeTab}
        onChange={(val) => {
          setActiveTab(val);
          if (val === "2" || val === "3") {
            setHasOpenedWipTab(true);
          }
        }}
        variant="separated"
        styles={{
          control: {
            border: '1px solid #ccc',
            padding: '0.5rem',
          },
          item: {
            marginTop: '1rem',
          },
        }}
      >
        {tabs
          .filter(tab => tab.id === "1" || tab.id === "2" || tab.id === "3")
          .map((tab) => (
            <Accordion.Item key={tab.id} value={tab.id} style={{
              backgroundColor: activeTab === tab.id && '#f8f9fa',
              borderRadius: '8px'
            }}>
              <Accordion.Control
                styles={{
                  label: {
                    fontSize: '20px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    width: '100%',
                    color: activeTab === tab.id ? '#8BC53F' : 'black',
                  },
                  control: {
                    border: activeTab === tab.id ? '0px solid #ccc' : '1px solid #ccc',
                  },
                }}
              >
                {tab.name}
              </Accordion.Control>
              <Accordion.Panel>
                <fieldset disabled={isViewOnly} style={{ border: 'none', padding: 0, margin: 0, pointerEvents: isViewOnly ? 'none' : 'auto', opacity: isViewOnly ? 0.9 : 1 }}>
                  {renderActiveComponent()}
                </fieldset>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
      </Accordion>
      <div className='productType-btn' style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '1rem', marginBottom: '5rem' }}>
        {(!isFetching && !isRejected) && (
          <B2BButton
            name={isSaving ? "Saving..." : "Save"}
            onClick={handleProductSave}
            disabled={isSaving}
            style={{ backgroundColor: isSaving ? "gray" : "#8BC53F", color: "white" }}
          />
        )}
      </div>
    </ProductContext.Provider>
  );
};

export default CreateProduct;